import { useCallback } from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { OAuthCredential } from 'firebase/auth';
import { AuthActions, AuthState } from 'store/ducks/auth';

export const useFirebaseAuth = () => {
  const dispatch = useDispatch();

  const { loading } = useSelector<RootStateOrAny, AuthState>(
    (state: RootStateOrAny) => state
  );

  const signIn = useCallback(
    async (credential: OAuthCredential): Promise<void> => {
      dispatch(AuthActions.firebaseLoginRequest(credential));
    },
    [dispatch]
  );

  return {
    signIn,
    loading,
  };
};
